const HEADER_ACTIVE: string = 'header--active';

const navbarInit = (header: HTMLElement) => {
  const headerMenu = header.querySelector('.header__menu');
  const togglers = header.querySelectorAll('.header__toggler');

  // Add active class to current click
  // and stop propagation
  togglers.forEach((toggler) => {
    toggler.addEventListener('click', (e: Event) => {
      e.stopPropagation();
      header.classList.toggle(HEADER_ACTIVE);
      document.body.classList.toggle('no-scroll');
    });
  });

  // Stop propagation when clicking on
  // element with .header__menu class
  headerMenu.addEventListener('click', (e: Event) => {
    e.stopPropagation();
  });
};

export default navbarInit;
